export class ApiEndPoints {
    ////local
    //public static BaseURL = "http://localhost:55555/";
	public static BaseURL = "http://mfhcardportal.staging.x-rm.com/";
    //public static APIBaseURL = "https://eservices-api-goldvision-uat-dev-v8.fuelcard-group.com/";
    //public static APIDrawingsReportURL = "https://mfhreporting.staging.x-rm.com/";
    //public static XRMLoginASUrl = "https://myfleethub.staging.x-rm.com/connect/loginas?impersonatedUserId=";
    //public static XRMUserInfo = "https://myfleethub.staging.x-rm.com/connect/userinfo";


    //staging
    //public static BaseURL = "https://staging.myfleethub.co.uk/";
    public static APIBaseURL = "https://eservices-api-goldvision-uat-dev-v8.fuelcard-group.com/";
    public static APIDrawingsReportURL = "https://mfhreporting.staging.x-rm.com/";

    public static XRMLoginASUrl = "https://myfleethub.staging.x-rm.com/connect/loginas?impersonatedUserId=";
    public static XRMUserInfo = "https://myfleethub.staging.x-rm.com/connect/userinfo";


    ////live
    //public static BaseURL = "https://www.myfleethub.co.uk/";
    //public static APIBaseURL = "https://gv-eservices-api.fuelcard-group.com/";
    //public static APIDrawingsReportURL = "https://reports.myfleethub.co.uk/";

    //public static XRMLoginASUrl = "https://login.myfleethub.co.uk/connect/loginas?impersonatedUserId=";
    //public static XRMUserInfo = "https://login.myfleethub.co.uk/connect/userinfo";



    public static UseDirectEndPoint: boolean = false;



    public static OAuthEndPoint = ApiEndPoints.APIBaseURL + "oauth2/token";
    public static ResetPasswordEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/passwords";
    public static ConfirmPasswordEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/passwords";
    public static AccountAccessEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/{userId}/accounts";
    public static WelcomeMessage = ApiEndPoints.APIBaseURL + "1.0/users/{userId}/welcome";

    //Survey
    public static SurveyEndPoint = ApiEndPoints.APIBaseURL + "1.0/surveys";
    public static MailSurveyEndPoint = ApiEndPoints.APIBaseURL + "1.0/mailsurveys";

    //Users Section
    public static UserEndPointV1 = ApiEndPoints.APIBaseURL + "1.0/users/{userId}";
    public static UserEndPoint = "1.0/users/{userId}";
    public static UserEndPointV2 = "1.0/users/{userId}";
    public static UserCreateEndPoint = ApiEndPoints.APIBaseURL + "1.0/users";
    public static UserUpdateEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/{userId}";
    public static UserDeleteEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/{userId}";
    public static UserListEndPoint = ApiEndPoints.APIBaseURL + "1.0/companies/{companyId}/users";
    public static UserChangePasswordEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/{userId}/passwords";
    public static UserDrawingPointAccessEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/{userId}/drawingpoints";
    public static UserForcePasswordChangeEndPoint = ApiEndPoints.APIBaseURL + "1.0/users/passwords";


    //CardsTransaction
    public static CardsEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/live?accountNumber={accountNumber}";
    public static DrawingPointEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/drawingpoints";
    public static DrawingEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/drawings?";
    public static CO2CountsEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/drawings?";


    //Report Section
    public static UnusualMilesEndPoint = ApiEndPoints.APIBaseURL + "1.0/reports/unusualmiles/{accountId}";
    public static UninvoicedDrawingsPoint = ApiEndPoints.APIBaseURL + "1.0/reports/uninvoiceddrawings/{accountId}";
    public static CardMisusageEndPoint = ApiEndPoints.APIBaseURL + "1.0/reports/cardmisusage/{accountId}";
    public static AutomatedDrawingsEndPoint = ApiEndPoints.APIBaseURL + "1.0/reports/automateddrawings/{accountId}";

  public static LoadDrawingReportCompanyByAcId = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/companies/{acid}";
  public static LoadDrawingReportCompany = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/companies";
  public static UninvoicedDrawingsRegisterCompanyPoint = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/Companies/{acid}";
  public static UninvoicedDrawingsRegisterCompanyUserPoint = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/RegisterNewUserEmail";
  public static LoadDrawingReportUsersByUserId = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/UserEmails/{id}";
  public static LoadDrawingReportUsers = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/Companies/{companyAcId}/UserEmails";
  public static UnRegisterCompanyPoint = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/Companies/{acid}/Unregister";
  //public static UnRegisterCompanyPoint = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/UnRegisterCompany/{acid}";
  public static UnRegisterCompanyUserPoint = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/UnRegisterCompanyUser?AcId={acid}&Email={email}";
  public static DeleteRegisterCompanyUserPoint = ApiEndPoints.APIDrawingsReportURL + "api/DrawingsReport/UserEmails/{id}";

    //Invoices Section
    public static StatementsEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/statements";
    public static StatementByIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/statements/{statementId}";
    public static InvoicesEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/invoices";
    public static InvoiceByIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/invoices/{invoiceId}";

    public static InvoiceByFileNameEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/invoices/{fileName}";
    public static InvoiceByFileNameEndPointNew = ApiEndPoints.APIBaseURL + "1.0/invoices/{fileName}";

    public static CertificatesEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/co2certificates";
    public static CertificateByIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/co2certificates/{certificateId}";
    public static CertificateByIdEndPointNew = ApiEndPoints.APIBaseURL + "1.0/co2Certificates/{certificateId}";

    public static EbillingEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/ebilling";
    public static LedgerLinesEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/ledgerlines";
    public static HistoricalInvoicesEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/historical-invoices";
    public static HistoricalInvoiceDocumentByIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/historical-invoices/{invoiceId}";

    //Managecards
    public static LiveCardsEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/live?accountNumber={accountNumber}"
    public static CostCentresByCardIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/{cardId}/costcentres"
    public static DrawingsByCardIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/{cardId}/drawings?limit=250"
    public static CardByIdEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/{cardId}"
    public static PendingStopCardsEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/pendingstop?accountNumber={accountNumber}"
    public static ReduntantCardsEndPoint = ApiEndPoints.APIBaseURL + "1.0/cards/dead?accountNumber={accountNumber}"
    public static CreateCardDrawingPointEndPoint = ApiEndPoints.APIBaseURL + "1.0/accounts/{accountId}/drawingpoints";
    public static PurchaseOptionsEndPoint = ApiEndPoints.APIBaseURL + "1.0/purchaseoptions/";
    public static CompanyCardAddressEndPoint = ApiEndPoints.APIBaseURL + "1.0/companies/{companyId}/cardaddresses";
    public static CreateCardsEndPoint = ApiEndPoints.APIBaseURL + "1.0/cardrequests/order";
    public static StopCardsEndPoint = ApiEndPoints.APIBaseURL + "1.0/cardrequests/stop";
    public static CardHistoryEndPoint = ApiEndPoints.APIBaseURL + "1.0/cardrequests";
    public static CardRequestEndPoint = ApiEndPoints.APIBaseURL + "1.0/cardrequests/{requestId}/cards";

    //MFT Own API Service
    public static DownloadCardTransEndPoint = "api/get-cardtransactions-document/{id}/{type}";
    public static DownloadNewCardTransEndPoint = "api/get-cardtransactions-documentnew/{id}/{type}";
    public static PrePareCardTransEndPoint = "api/prepare-cardtransactions-document/{id}/{type}/{sort}/{co2}";
    public static GetInvoices = "api/get-invoices";
    public static DownloadInvoiceEndPoint = "api/get-invoice-document";
    public static GetStatements = "api/get-statements";
    public static DownloadStatementEndPoint = "api/get-statement-document";
    public static GetCertificates = "api/get-certificates";
    public static RequestCertificateEndPoint = "api/request-certificate-document";
    public static DownloadCertificateEndPoint = "api/get-certificate-document";
    public static GetCardHistories = "api/get-cardhistory";
    public static GetCardRequests = "api/get-requestedcards";
    public static GetLiveCards = "api/get-livecards";
    public static GetLiveCardsNew = "api/get-livecards-new";
    public static GetLiveCardsData = "api/get-livecards-data";
    public static DownloadNewLiveCardEndPoint = "api/get-livecard-documentnew/{id}/{type}";
    public static PrePareLiveCardsEndPoint = "api/prepare-livecards-document/{id}/{type}/{sort}";
    public static GetStopCards = "api/get-stopcards";
    public static GetPendingStopCards = "api/get-pendingstopcards";
    public static GetReduntantCards = "api/get-reduntantcards";
    public static GetCardTranLiveCards = "api/get-cardtran-livecards";
    public static GetCardTranDrawingPoints = "api/get-cardtran-drawingpoints";
    public static GetCardTranDrawings = "api/get-cardtran-drawings";
    public static GetCardTranDrawingsNew = "api/get-cardtran-drawings-new";
    public static GetCardTranDrawingsData = "api/get-cardtran-drawings-data";
    public static GetCO2Counts = "api/get-co2-count";
    public static CallContact = "api/contact";
    public static SendEnquiry = "api/sendenquiry";
    public static CallRegister = "api/register";

    public static GetHistoricalInvoices = "api/get-historical-invoices";
    public static DownloadHistoricalInvoiceEndPoint = "api/get-historical-invoice-document";

    //public static BlogAPIUrl = "https://www.driversclubonline.co.uk/wp-json/wp/v2/posts?per_page=100";
    public static BlogAPIUrl = "api/get-blogs?categoryid=";
    public static OffersAPIUrl = "api/get-offers?categoryid=";
    public static DrivingArticlesAPIUrl = "api/get-drivingarticles";
    public static DriversClubNewsAPIUrl = "api/get-driversclubnews";

    public static OAuthEndPointServer = "api/oauth";
    public static ResetPasswordEndPointServer = "api/forgottenpassword";
    public static ResetPasswordEndPointPutServer = "api/resetpassword";
    public static AccountAccessEndPointServer = "api/accountaccess";
    public static SurveyEndPointServer = "api/survey";
    public static MailSurveyEndPointServer = "api/mailsurvey";

    public static UserEndPointServer = "api/getuser";
    public static UserCreateEndPointServer = "api/createuser";
    public static UserUpdateEndPointServer = "api/updateuser";
    public static UserDeleteEndPointServer = "api/deleteuser";
    public static UserListEndPointServer = "api/getusers";
    public static UserChangePasswordEndPointServer = "api/changepassword";
    public static UserDrawingPointAccessEndPointServer = "api/getuserdrawingpoints";
    public static UserDrawingPointAccessEndPointSaveServer = "api/saveuserdrawingpoints";
    //public static UserForcePasswordChangeEndPointServer = "https://eservices.fuelcardservices.com/xyz/1.0/users/passwords";

    public static UnusualMilesEndPointServer = "api/getunusualmile";
    public static UnusualMilesEndPointSaveServer = "api/updateunusualmile";
    public static UninvoicedDrawingsPointServer = "api/getuninvoiceddrawing";
    public static UninvoicedDrawingsPointSaveServer = "api/updateuninvoiceddrawing";
    public static CardMisusageEndPointServer = "api/getcardmisusage";
    public static CardMisusageEndPointSaveServer = "api/updatecardmisusage";
    public static AutomatedDrawingsEndPointServer = "api/getautomateddrawing";
    public static AutomatedDrawingsEndPointSaveServer = "api/updateautomateddrawing";

  public static LedgerLinesEndPointServer = "api/getledgerlines";
  public static LedgerLinesNewEndPointServer = "api/getledgerlinesnew";
  public static EbillingEndPointServer = "api/getebilling";
  public static EbillingEndPointSaveServer = "api/updateebilling";

    public static CostCentresByCardIdEndPointServer = "api/getcostcentres"
    public static CostCentresByCardIdEndPointSaveServer = "api/createcostcentre"
    public static CostCentresByCardIdEndPointDeleteServer = "api/deletecostcentre"
    public static CardByIdEndPointServer = "api/getcarddetails"
    public static DrawingsByCardIdEndPointServer = "api/getcarddrawings"
    public static CreateCardDrawingPointEndPointServer = "api/getdrawingpoints";
    public static PurchaseOptionsEndPointServer = "api/getpurchaseoptions";
    public static CompanyCardAddressEndPointServer = "api/getcardaddresses";
    public static CompanyCardAddressEndPointSaveServer = "api/createcardaddress";
    public static CompanyCardAddressEndPointDeleteServer = "api/deletecardaddress";
    public static CreateCardsEndPointSaveServer = "api/createcard";
    public static StopCardsEndPointSaveServer = "api/stopcard";

    public static WelcomeMessageServer = "api/welcome";
    public static StandardUserEnableForcePasswordChange = "api/checkstandarduserforcepasswordchange";
    public static StandardUserEnableUpdateUserProfile = "api/checkstandarduserenableupdateuserprofile";


    //unsubscribe memoryleaks api
    public static CardTransactionMemoryLeak = "api/unsubscribe-cardtransaction-memoryleak/{userId}";
    public static ClearMemoryLeak = "api/clear-memoryleak/{userId}";
    public static ClearMemoryLeakCommon = "api/clear-memoryleak-common/{userId}/{type}";
    //public static StopCardsMemoryLeak = "api/stop-memoryleak/{userId}";
}



// WEBPACK FOOTER //
// ./src/app/api.endpoints.ts